/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination"
import { Table } from "@tanstack/react-table"

export const TablePagination = ({
  table,
}: {
  table: Table<any>
}) => {

  const pageIndex = table.getState().pagination.pageIndex
  const pageCount = table.getPageCount()

  return (
    <div className="flex w-full items-center justify-end">
      {pageCount > 1 && (
        <div className="flex justify-center py-4">
          <Pagination>
            <PaginationContent>
              <PaginationItem className="cursor-pointer">
                <PaginationPrevious
                  onClick={(e) => {
                    e.preventDefault()
                    table.previousPage()
                    if (table.getCanPreviousPage()) table.previousPage()
                  }}
                  className="hover:bg-border/5"
                  aria-disabled={!table.getCanPreviousPage()}
                />
              </PaginationItem>
              {/* Previous page number */}
              {pageIndex > 0 && (
                <PaginationItem className="cursor-pointer">
                  <PaginationLink
                    onClick={(e) => {
                      e.preventDefault()
                      if (pageIndex > 0) table.setPageIndex(pageIndex - 1);
                    }}
                    className="hover:bg-border/5 h-8 w-8"
                  >
                    {pageIndex}
                  </PaginationLink>
                </PaginationItem>
              )}
              {/* Current page number */}
              <PaginationItem className="cursor-not-allowed">
                <PaginationLink isActive className="h-8 w-8">
                  {pageIndex + 1}
                </PaginationLink>
              </PaginationItem>
              {/* Next page number */}
              {pageIndex < pageCount - 1 && (
                <PaginationItem className="cursor-pointer">
                  <PaginationLink
                    onClick={(e) => {
                      e.preventDefault()
                      if (pageIndex + 1 < pageCount) table.setPageIndex(pageIndex + 1);
                    }}
                    className="hover:bg-border/5 h-8 w-8"
                  >
                    {pageIndex + 2}
                  </PaginationLink>
                </PaginationItem>
              )}
              <PaginationItem className="cursor-pointer">
                <PaginationNext
                  onClick={(e) => {
                    e.preventDefault()
                    if (table.getCanNextPage()) table.nextPage()
                  }}
                  className="hover:bg-border/5"
                  aria-disabled={!table.getCanNextPage()}
                />
              </PaginationItem>
            </PaginationContent>
          </Pagination>
        </div>
      )}
    </div>
  )
}
